// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var SwapType;
(function (SwapType) {
    SwapType[SwapType["SWAP_IN_CURRENCY"] = 0] = "SWAP_IN_CURRENCY";
    SwapType[SwapType["SWAP_IN_PERCENT"] = 1] = "SWAP_IN_PERCENT";
    SwapType[SwapType["SWAP_IN_PIPS"] = 2] = "SWAP_IN_PIPS";
})(SwapType || (SwapType = {}));
